import { textChooser } from "../../../util/textChooser";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../icons";
import "./goback.style.scss";

interface GobackProps {
    goBackNumOfPages?: number;
}

export const GoBack = ({goBackNumOfPages}: GobackProps) => {
    const navigate = useNavigate();
    
    return (
        <div className="go-back-wrapper">
            <button className={"go-back-btn"} onClick={() => navigate(goBackNumOfPages ?? -1)}>
                <Icon type={"goBack"}/>{textChooser("txt15")}
            </button>
        </div>
    )
}